/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data, shop) {
  const [seeMore, setSeeMore] = useState(false)
  const [saller, setSaller] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setSaller(data.data)
  }, [data])

  return (
    <>
      <div style={seeMore ? { } : { maxHeight: '330px', overflow: 'hidden' }}>
        <table className='table'>
          <thead>
            <tr>
              <th>سفارش دهنده</th>
              <th>تعداد سفارش</th>
              <th>گرید</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {saller ? saller.map((item, index) => 
                <tr key={item._id}>
                  <td>{item[0]}</td>
                  <td>{item[1]}</td>
                  <td style={index === 0 || index === 1 || index === 2 ? { color : '#198524' } : {}}>{index === 0 || index === 1 || index === 2 ? 'Top' : '-'}</td>
                  <td>
                    <button onClick={() => navigate(`/users`)}>مشاهده</button>
                  </td>
                </tr>) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
          </tbody>
        </table>
      </div>
      <div className='tableVisibleBtn' style={seeMore ? { display: 'none' } : { }}>
        <span onClick={() => setSeeMore(true)}>
          مشاهده بیشتر 
        </span>
      </div>
    </>
  );
}
